export const isDemo = import.meta.env.MODE === 'demo';
export const defaultOrganizationId = import.meta.env.VITE_DEFAULT_ORGANIZATION_ID;